import { createSelector } from 'reselect'
import {
  NarrationModel,
  selectAllNarrations,
} from '@store/slices/narration.slice'
import { RootState } from '@store/store'

export const selectNarrationBySlotAndRegion = createSelector(
  selectAllNarrations,
  (state: RootState, props: { slotId: string; regionId: string }) => [
    props.slotId,
    props.regionId,
  ],
  (narrations: NarrationModel[], [slotId, regionId]) =>
    narrations.find(
      (narration: NarrationModel): boolean =>
        narration.aiSlot == slotId && narration.region == regionId
    )
)
